/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useState, useEffect, useContext, useRef, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import { GetCommonData } from './FilterDataSlice.js'
import AcademicReportsEmptyScreen from './Components/EmptyScreen'
import { dataService } from '../../../services/data.services.js';
import { Link, useNavigate } from 'react-router-dom';
import Table from './Components/Table';
import S3UploadHook from '../../../CommonMethods/S3UploadHook';
import GlobalContext from '../../../components/Context/GloablContext';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import Loader from '../../../components/Loader';
import Filter from '../Attendance/Components/Filter';
import Toast from '../../../components/Toast';
import { GetBranchId } from '../../../CommonMethods/GetBranchId.js';
import AnimatedButton from '../../../components/Animation/AnimatedButton';

const AcademicRecords = () => {
    const { isSideNavBar, setToastmessage, swithBranch, isInactiveBranch } = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams({ page_number: 1 });
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();
    const [selectedAYID, setSelectedAYID] = useState(searchParams.get("academic_year_id") === null ? '' : searchParams.get('academic_year_id'))
    const [selectedClassID, setSelectedClassID] = useState(searchParams.get("class_id") === null ? '' : searchParams.get('class_id'))
    const [selectedSectionID, setSelectedSectionID] = useState(searchParams.get("section_id") === null ? '' : searchParams.get('section_id'))
    const [selectedExamID, setSelectedExamID] = useState(searchParams.get("exam_id") === null ? '' : searchParams.get('exam_id'))
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [loading, setLoading] = useState(false);
    const [emptyScreen, setEmptyScreen] = useState(false);
    const [initialScreen, setInitialScreen] = useState(true);
    const [filters, setFilters] = useState('academic_year');
    const [onBlurState, setOnBlurState] = useState(false)
    const [selectedFilterParams, setSelectedFilterParams] = useState({
        academic_year: '',
        class: '',
        section: '',
        exam: '',
    })

    const [studentReportDetails, setStudentReportDetails] = useState([])
    const [progressCount, setprogressCount] = useState(0)
    const [pageCount, setPageCount] = useState({})
    const [dotLoader, setDotLoader] = useState('')
    const [academicStatus, setAcademicStatus] = useState('')
    const [threeDottedButtonLoading, setThreeBottedButtonLoading] = useState(false)
    const [dottedDopDown, setDottedDropDown] = useState(false);
    /**
    * The function `handleOnClickPageNumber` updates the search parameters with a new page number and
    * sets the loading state to true.
    */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams);
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
        handleFetchRecords(`&academic_year_id=${selectedAYID}&exam_id=${selectedExamID}&class_id=${selectedClassID}&section_id=${selectedSectionID}&page_number=${pageNum.selected + 1}&limit=10&sort=${encodeURIComponent('student_id+asc')}`)
    }


    /* The above code is defining a function called `handleFetchRecords` using the `useCallback` hook
    in React. This function is responsible for fetching academic records from an API endpoint. */
    const handleFetchRecords = useCallback(async (endPoint) => {
        try {
            const branch_id = await GetBranchId()
            const response = await dataService.GetAPI(`academic-reports?branch_id=${branch_id}&filter=true${endPoint}`);
            if (response.data.status === 200) {
                if (response.data.data.academicReports?.length === 0) {
                    setLoading(false)
                    setInitialScreen(false)
                    setEmptyScreen(true)
                    setStudentReportDetails(response.data.data.academicReports)
                    setAcademicStatus(response.data.data.academic_year_status.status)
                } else {
                    setLoading(false)
                    setInitialScreen(false)
                    setStudentReportDetails(response.data.data.academicReports)
                    setAcademicStatus(response.data.data.academic_year_status.status)
                    setPageCount(response.data.data)
                    setEmptyScreen(false)
                }
            }
        } catch (error) {
            setLoading(false)
            setInitialScreen(false)
            setEmptyScreen(true)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }, [searchParams]);


    const handleSampleFileDownload = async () => {
        setDotLoader('sample');
        try {
            const branch_id = await GetBranchId();
            let body = {
                "academic_year_id": selectedAYID,
                "class_id": selectedClassID,
                "section_id": selectedSectionID,
                "branch_id": branch_id,
            };
            const url = await dataService.PostAPI(body, `academic-reports/download-sample-report`);
            window.open(url.data.data.pre_signed_url, '_blank');
            setToastmessage(url.data.data.message);
        } catch (error) {
            setDotLoader('');
            console.error("Error:", error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally {
            setDotLoader('');
        }
    };


    /**
     * The function `handleExport` sends a POST request to the server to export an academic report and
     * opens the generated report in a new window.
     */
    const handleExport = async () => {
        try {

            if (loading) {
                return;
            }

            if (studentReportDetails?.length == 0) {
                setToastErrorMessage("No records to export");
                return;
            }

            const branch_id = await GetBranchId();
            setDotLoader('export');
            let body =
            {
                "academic_year_id": selectedAYID,
                "class_id": selectedClassID,
                "section_id": selectedSectionID,
                "exam_id": selectedExamID,
                "branch_id": branch_id
            };
            const response = await dataService.PostAPI(body, `academic-reports/export-academic-report`);
            if (response.data.status === 201) {
                setToastmessage(response.data.data.message);
                window.open(response.data.data.pre_signed_url);
            }
            else {
                setToastErrorMessage("Something went wrong");
            }
        } catch (error) {
            setDotLoader('');
            console.error("Error occurred:", error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally {
            setDotLoader('');
        }
    };

    /**
     * The function `handleImport` handles the import of a file, checks if the file meets certain
     * criteria, and uploads the file to an S3 bucket if it passes the checks.
     * @returns nothing (undefined).
     */
    async function handleImport(e) {
        setDotLoader('import');
        const branch_id = await GetBranchId()
        let file = e.target.files[0];
        let url = ''
        if (file.name && file.type) {
            url = await S3UploadHook(file, `academic-reports/${branch_id}/${selectedAYID}/${searchParams.get('academic_year')}/${selectedClassID}/${searchParams.get('class_name')}/${selectedSectionID}/${searchParams.get('section_name')}/${selectedExamID}/${searchParams.get('exam')}.${file.name.split('.')[file.name.split('.')?.length - 1]}`, setprogressCount, true);
            let body = {
                s3_key: url
            }
            try {
                setThreeBottedButtonLoading(true)
                const importresponse = await dataService.PostAPI(body, `academic-reports/upload`)
                handleFetchRecords(`&academic_year_id=${selectedAYID}&exam_id=${selectedExamID}&class_id=${selectedClassID}&section_id=${selectedSectionID}&page_number=${searchParams.get('page_number') === null ? "1" : searchParams.get('page_number')}&limit=10&sort=${encodeURIComponent('student_id+asc')}`)
                setToastmessage(importresponse.data.data.message)
                e.target.value = null;
            } catch (error) {
                setThreeBottedButtonLoading(false)
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            }
            setThreeBottedButtonLoading(false)
        }
        e.target.value = null;
        setDotLoader('');
    }

    /* The above code is a useEffect hook in a React component. It is used to perform certain actions
   when the component mounts or when certain dependencies change. */
    useEffect(() => {
        if (searchParams.get('academic_year')) {
            handleFetchRecords(`&academic_year_id=${selectedAYID}&exam_id=${selectedExamID}&class_id=${selectedClassID}&section_id=${selectedSectionID}&page_number=${searchParams.get('page_number') === null ? "1" : searchParams.get('page_number')}&limit=10&sort=${encodeURIComponent('student_id+asc')}`)
        }
    }, [])

    /**
     * The function `handleApplyApi` sets loading to true, creates an object with selected filter
     * parameters, sets search parameters to the object, and calls `handleFetchRecords` with the
     * appropriate query parameters.
     */
    const handleApplyApi = () => {
        setLoading(true);
        let obj = {
            academic_year: selectedFilterParams.academic_year,
            class_name: selectedFilterParams.class,
            section_name: selectedFilterParams.section,
            exam: selectedFilterParams.exam,
            academic_year_id: searchParams.get("academic_year_id") === null ? selectedAYID : searchParams.get("academic_year_id"),
            class_id: searchParams.get("class_id") === null ? selectedClassID : searchParams.get('class_id'),
            section_id: searchParams.get("section_id") === null ? selectedSectionID : searchParams.get('section_id'),
            exam_id: searchParams.get("exam_id") === null ? selectedExamID : searchParams.get("exam_id"),
        }
        setSearchParams(obj);
        handleFetchRecords(`&academic_year_id=${selectedAYID}&exam_id=${selectedExamID}&class_id=${selectedClassID}&section_id=${selectedSectionID}&page_number=${searchParams.get('page_number') === null ? "1" : searchParams.get('page_number')}&limit=10&sort=${encodeURIComponent('student_id+asc')}`)
        // handleFetchRecords(`&academic_year=${selectedFilterParams.academic_year}&exam=${selectedFilterParams.exam}&class_name=${selectedFilterParams.class}&section_name=${selectedFilterParams.section}&page_number=${searchParams.get('page_number') === null ? "1" : searchParams.get('page_number')}&limit=10&sort=${encodeURIComponent('student_id+asc')}`)
    }

    /**
     * The function `handleEditMarks` sets the loading state to true and then fetches records based on
     * the search parameters.
     */
    const handleEditMarks = () => {
        setLoading(true);
        handleFetchRecords(`&academic_year_id=${selectedAYID}&exam_id=${selectedExamID}&class_id=${selectedClassID}&section_id=${selectedSectionID}&page_number=${searchParams.get('page_number') === null ? "1" : searchParams.get('page_number')}&limit=10&sort=${encodeURIComponent('student_id+asc')}`)
    }

    /**
     * The function `handleClearFilter` sets various state variables to their initial values and
     * updates the loading state.
     */
    const handleClearFilter = () => {
        setLoading(true);
        setIsFilterOpen(false)
        setSearchParams()
        setStudentReportDetails([])
        setInitialScreen(true)
        setLoading(false);
    }

    const filterRef = useRef(null);
    /* The above code is defining a function called `useOnClickOutside` that takes two arguments:
    `filterRef` and an arrow function. Inside the function, it is calling `setIsFilterOpen(false)`
    to set the state variable `isFilterOpen` to `false`. This function is likely used to handle a
    click event that occurs outside of a specific element referenced by `filterRef`. */
    useOnClickOutside(filterRef, () => {
        setIsFilterOpen(false)
    })


    const handleDottedDropDown = () => {
        setDottedDropDown(!dottedDopDown)
    }

    const validateFilters= (e) => {
        if (loading) {
            e.preventDefault();
            return;
        }
        if (!searchParams.get('academic_year') || searchParams.get('academic_year') === null) {
            e.preventDefault();
            setToastErrorMessage("Select AY, Class, Section and Exam from Filter");
            return;
        }
        else if (academicStatus === 'completed' && e.target.id !== "Sample Upload File") {
            e.preventDefault();
            setToastErrorMessage("AY Completed. Academic Reports cannot be uploaded");
            return;
        }
        if(e.target.id === "Sample Upload File")
        {
            handleClickDropDown(e)
        }
    }

    const handleClickDropDown = (e) => {
        setDottedDropDown(!dottedDopDown)
        handleThreeDottedButton(e)

    }

    const handleThreeDottedButton = (e) => {
        if (e.target.id === "Sample Upload File") {
            handleSampleFileDownload()
        } else {
            if (academicStatus === "completed") {
                return;
            }
            handleImport(e)
        }
    }

    const threeDottedRef = useRef()
    useOnClickOutside(threeDottedRef, () => {
        setDottedDropDown(false)
    })


    return (
        <>
            <div class={`w-full main-screenInst overflow-x-hidden relative overflow-y-auto h-screen`}>
                <div className={`mainDataCntnr ${!isSideNavBar ? 'normal' : 'wide'}`}>
                    <div class="mainDataCntnrTop shadow-s13">
                        <div class="flex items-center">
                            <h5 class="pageHeader adderror">Class Wise Academic Reports</h5>
                        </div>
                        <div class="flex items-center">
                            <div class="relative" ref={filterRef}>
                                <button onClick={() => setIsFilterOpen(!isFilterOpen)} type="button" id="filter_btn" >
                                    <img src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]" />
                                    <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                                    {searchParams.get('academic_year') &&
                                        <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">4</p>}
                                </button>
                                {isFilterOpen && <Filter
                                    FilterArray={["Academic Year", "Class", "Section", "Exam"]}
                                    setSearchParams={setSearchParams}
                                    setIsFilterOpen={setIsFilterOpen}
                                    searchParams={searchParams}
                                    academicReports={true}
                                    setSelectedAYID={setSelectedAYID}
                                    setSelectedClassID={setSelectedClassID}
                                    setSelectedSectionID={setSelectedSectionID}
                                    setSelectedExamID={setSelectedExamID}
                                    handleApplyApi={handleApplyApi}
                                    handleClearFilter={handleClearFilter}
                                    selectedFilterParams={selectedFilterParams}
                                    setSelectedFilterParams={setSelectedFilterParams}
                                    setLoading={setLoading}
                                    selectedAYID={selectedAYID}
                                    selectedClassID={selectedClassID}
                                />}
                            </div>
                            <button
                                id="export"
                                type="button"
                                class={`prmy-btn export_btn`}
                                onClick={() => handleExport()}
                            >
                                {dotLoader === 'export' ? <Loader /> : 'Export'}
                            </button>

                            {!isInactiveBranch &&
                            <div className='relative' ref={threeDottedRef}>
                                <button
                                    type="button"
                                    className="more_actn_btn"
                                    id="three_dotted"
                                    
                                    onClick={() => {
                                        if (threeDottedButtonLoading) {
                                            return;
                                        } else {
                                            handleDottedDropDown()
                                        }
                                    }}
                                >
                                    {threeDottedButtonLoading ? <div className='flex items-center justify-center pt-[5px] w-[35px]'>
                                        <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-[20px] w-[20px] mb-4 spin-animation px-2"></div>
                                    </div> : <img src="/images/three_dotted_download.svg" alt="" />}
                                </button>

                                {(dottedDopDown) && <ul className='three_dot_btn_drp_dwn wid4 top1 shadow-s1'>
                                    <li>
                                        <AnimatedButton
                                            handleClick={validateFilters}
                                            buttonName={"Sample Upload File"}
                                            className="w-full text-left px-3 cursor-pointer  font-normal text-[#031624] hover:text-[#106EB4] mt-1.5" />

                                    </li>
                                    <li>
                                        <div className={`w-full text-left relative px-3 cursor-pointer font-normal text-[#031624] mt-3 hover:text-[#106EB4]`}>
                                            <label className="cursor-pointer">
                                                <span>Upload Academic Reports</span>
                                                <input
                                                    id="Upload"
                                                    onChange={(e) => handleClickDropDown(e)}
                                                    onClick={(e) => validateFilters(e)}
                                                    accept=".xlsx, .xls"
                                                    data-allowed-file-extensions=".xlsx,.xls"
                                                    type="file"
                                                    className={`opacity-0 absolute top-0 left-0 w-full h-full importBtn`}
                                                    title=""
                                                />
                                            </label>
                                        </div>

                                    </li>
                                </ul>
                                }
                            </div>}
                        </div>
                    </div>
                    <div className='mainDataCntnrListDiv scrollBlue_thick '>
                        {loading ? (<ItemShimmer classkey={"mt-[32px]"} />) : (
                            <>

                                {(searchParams.get('academic_year')) && <p id="filter-result" class="absolute">Displaying results for - AY: <span class="font-semibold">{searchParams.get('academic_year')}</span>, Class: <span class="font-semibold">{searchParams.get('class_name')}</span>, Section: <span class="font-semibold">{searchParams.get('section_name')}</span>, Exam: <span class="font-semibold">{searchParams.get('exam')}</span></p>}
                                <Table
                                    searchParams={searchParams}
                                    pageCount={pageCount}
                                    studentReportDetails={studentReportDetails}
                                    // handleApplyFilter={handleApplyFilter}
                                    handleApplyApi={handleEditMarks}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    AY_status={academicStatus}
                                />

                            </>
                        )}
                    </div>
                    {toastErrorMessage !== '' && <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />}
                </div>
            </div>
        </>
    )
}

export default AcademicRecords